require('lightgallery.js');

const $navbar = $('#nav');
const navbarHeight = $navbar.outerHeight();
const $mobileToggle = $('#mobile-toggle');
const mobileToggleTop = $mobileToggle.offset().top;

const stickMobileToggle = () => {
    if (window.pageYOffset > mobileToggleTop - navbarHeight) {
        $mobileToggle.addClass('sticky');
    } else {
        $mobileToggle.removeClass('sticky');
    }
};

window.addEventListener('scroll', () => {
    stickMobileToggle();
    $('.dropdown-menu.show').removeClass('show');
});


lightGallery(document.getElementById('gallery'), {
    selector: '.lightgallery-link',
    download: false,
    counter: false,
    prevHtml: '<img src="/images/static/carousel/ctrl-previous.png" alt="Image précédente">',
    nextHtml: '<img src="/images/static/carousel/ctrl-next.png" alt="Image suivante">',
    hideBarsDelay: 86400000 // 24h
});
